module.exports = require('./helpers/bundle-url').getBundleURL('8g68e') + "invisalign.a9e5ee18.svg";